module.exports.default = {
    "ORDER": "הזמנה",
    "SCHEDULE.YOU_ARE_ALL_SET": "זמן המשלוח הוגדר בהצלחה",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "הזמנתך נקבעה ל",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "שלום #, אנא בחר תאריך למשלוח",
    "SCHEDULE.SCHEDULE_NOW": "בחר חלון",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "מרכז שליחת התראות",
    "SCHEDULE.EMAIL_UPDATES": "מעוניין לקבל הזמנות באימייל",
    "SCHEDULE.SMS_UPDATES": "מעוניין לקבל התראות ב sms",
    "SCHEDULE.DISABLE_UPDATES": "לא מעוניין לקבל התראות",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "אני מעוניין לקבל התראות בערוצים הבאים:",
    "OOPS": "אופס!",
    "SOMETHING_WENT_WRONG": "אירעה שגיאה",
    "REFRESH": "רענון",
    "PAGE_NOT_FOUND": "הדף לא נמצא",
    "COULD_NOT_FIND_PAGE": "הדף שחיפשת אינו נמצא",
    "TRACKING.MESSAGE_DRIVER_FAILED": "לא ניתן לשלוח הודעה ריקה",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "ניתן לשלוח הודעה לנהג",
    "TRACKING.SEND": "שלח",
    "TRACKING.ARRIVING_AT": "הגעה",
    "TRACKING.ETA": "הגעה",
    "TRACKING.MIN": "דקות",
    "TRACKING.MAP": "תנועה",
    "TRACKING.SATELLITE": "לווין",
    "TRACKING.TERRAIN": "שטח",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "!הגעתי",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "הגיע אל",
    "COMPLETED": "אין לך כרגע שליחויות פעילות",
    "RATING.SKIP": "לא כעת",
    "RATING.WHAT_WENT_WELL": "",
    "RATING.WHAT_WENT_WRONG": "",
    "RATING.THANK_YOU": "תודה !",
    "RATING.FOR_USING_OUR_SERVICE": "שבחרת להשתמש בשירות שלנו!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "איך הייתה חווית השירות שלך?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "עזרו לנו להשתפר ודרגו את השירות שקבלתם מהשליח",
    "SCHEDULE.RATE_US": "דרגו אותנו",
    "TERM_OF_USE": "תנאי שימוש",
    "PRIVACY_POLICY": "מדיניות פרטיות",
    "SHARING_MY_LOCATION": "שידור מיקום נוכחי",
    "SHARING_LOADING": "טוען",
    "REQUIRED_FIELD_MESSAGE": "שדות חובה",
    "CONTACT_NAME": "איש קשר",
    "PHONE_NUMBER": "נייד",
    "EMAIL_ADDRESS": "אימייל",
    "SEND": "שלח",
    "FORWARD.THIS_ORDER": "העבר קבלת הזמנה",
    "FORWARD.TO_CONTACT": "העבר לאיש קשר",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "האם ברצונך להעביר את ההזמנה לאיש קשר חדש?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "העביר/ה את הזמנתו אליך",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "האם ברצונך לדחות את ההזמנה?",
    "ACCEPT": "אשר",
    "REJECT": "דחה",
    "PICKUP.SET_PICKUP_TIME": "אני בדרך",
    "PICKUP.IVE_ARRIVED": "הגעתי",
    "PICKUP.PICKUP_ETA_SET_FAILED": "אופס, משהו השתבש",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "אנא נסה שנית",
    "PICKUP.MIN": "דקות",
    "PICKUP.SHOW_THIS_NUMBER": "הראה את מספרך בדלפק על מנת לקבל את הזמנתך",
    "PICKUP.IM_OUTSIDE": "אני כאן",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "האם הגעת ליעד?",
    "PICKUP.I_WILL_ARRIVE_AT": "אגיע ב:",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "זמן הגעה הוגדר בהצלחה",
    "PICKUP.IN": "ב",
    "PICKUP.TO": "ל",
    "PICKUP.COLLECT": "איסוף",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "בחר אמצעי תחבורה",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "אשר אמצעי תחבורה",
    "PICKUP.CANCEL": "ביטול",
    "PICKUP.CONFIRM_TIME": "אשר זמן הגעה",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "הנהג נמצא כתחנה אחת מיעדך",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "תחנות מיעדך",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "הנהג נמצא כ",
    "PICKUP.OK": "",
    "PICKUP.NEXT": "",
    "PICKUP.SKIP": "",
    "CAR_ARRIVED.TITLE": "",
    "CAR_ARRIVED.PARKING_SPOT": "",
    "CAR_ARRIVED.LICENSE_PLATE": "",
    "CAR_ARRIVED.VEHICLE_MODEL": "",
    "CAR_ARRIVED.VEHICLE_COLOR": "",
    "CAR_ARRIVED.REMEMBER": "",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "",
    "REDIRECT_PICKUP.TO": "",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "",
    "REDIRECT_PICKUP.FAILED_TITLE": "",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "",
    "REDIRECT_PICKUP.OK": "",
    "REDIRECT_PICKUP.KM": "",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "",
    "SOON": "",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "",
    "GLOBAL.CALL": "",
    "GLOBAL.CANCEL": "",
    "﻿PICKUP.SET_PICKUP_TIME": "",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "",
    "SCHEDULED.THANKS_FOR_USING": "",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "",
    "Submit": "",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "",
    "PICKUP.SHOW_ID": "הצג מספר",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "",
    "OPEN_MENU": "",
    "CLOSE_MENU": "",
    "MAP_AUTO_CENTER": "",
    "MAP_SETTINGS": "",
    "ZOOM_OUT": "",
    "ZOOM_IN": "",
    "TRACKING.CALL_DRIVER": "",
    "TRACKING.MESSAGE_DRIVER": "",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "",
    "SCHEDULE.TIME_ZONE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "",
    "TRACKING.THANKS_MESSAGE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_TITLE": "",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "",
    "CANCEL_ORDER": "",
    "CANCELLATION_VALIDATION_TITLE": "",
    "CANCELLATION_VALIDATION_BACK": "",
    "CANCELLATION_VALIDATION_YES": "",
    "CANCEL_SUCCESS": "",
    "CANCEL_PAST_ALLOWED": "",
    "CANCEL_ERROR": "",
    "RATING.FREE_TEXT_COMMENT": "",
    "RATING.ORDER_DELIVERED_GREEN": "",
    "CX_ORDER_STATUS.CONFIRMED": "ההזמנה אושרה. אנחנו על זה.",
    "CX_ORDER_STATUS.RECEIVED": "ההזמנה התקבלה. אנו ניצור קשר בקרוב.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "אנו מוצאים נהג להזמנה שלך.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "מצאנו את הנהג להזמנתך.",
    "CX_ORDER_STATUS.PICKING_UP": "אנו מרימים את ההזמנה שלך כרגע.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "אנחנו בדרך לאסוף את ההזמנה שלך.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "אנו מסיימים משלוח קודם לפני ההזמנה.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "ההזמנה שלך בדרך אליך עכשיו!",
    "CX_ORDER_STATUS.ARRIVED": "ההזמנה שלך הגיעה!",
    "TRACKING.DELIVERY_STATUS_TITLE": "סטטוס משלוח",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "הצג את סטטוס המסירה לצרכנים",
    "CONFIRM": "",
    "FLOW_OPTIONS.TITLE": "איך אתה רוצה לאסוף ההזמנה שלך?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "מועבר לרכב שלך במקום ייעודי",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "שפת המדרכה",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "לחץ ואסוף",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "",
    "RATING_STAR_ALT_TWO": "",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "",
    "SCHEDULE.EXTERNAL_ID_INFO": "",
    "SCHEDULE.TASK_NOTE_LABEL": "",
    "SCHEDULE.CANCEL_NOTE_INPUT": "",
    "DELIVERY_WAS_CANCELLED": ""
};
	